import { QuestionMarkIcon } from "../../Icons";
import React from "react";
import UnallocatedPostcodePopover from "./UnallocatedPostcodePopover";
import { View } from "../../Base";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  infoIcon: {
    margin: "0 4px 0 15px",
    fill: palette.typography.white.high,
    cursor: "pointer",
  },
  questionMarkIcon: {
    width: "16px",
    height: "16px",
  },
  fillOrange: {
    fill: palette.orange,
  },
}));

const UnallocatedPostcodeComponent = ({ unallocatedAreas }) => {
  const styles = useStyles();
  const [questionMarkAnchorEl, setQuestionMarkAnchorEl] = React.useState(null);

  return (
    <View className={styles.container}>
      <QuestionMarkIcon
        className={clsx(
          styles.infoIcon,
          styles.questionMarkIcon,
          questionMarkAnchorEl ? styles.fillOrange : null
        )}
        onClick={(event) =>
          unallocatedAreas?.length &&
          setQuestionMarkAnchorEl(event.currentTarget)
        }
      />
      {unallocatedAreas?.length || 0}
      <UnallocatedPostcodePopover
        unallocatedAreas={unallocatedAreas}
        open={!!questionMarkAnchorEl}
        onClose={() => setQuestionMarkAnchorEl(null)}
        anchorEl={questionMarkAnchorEl}
      />
    </View>
  );
};

export default UnallocatedPostcodeComponent;
